/* Glimmer — "Meus pedidos" (/search?view=conta) com login dentro do site:
   "Continuar com Google" ou código de 6 dígitos no e-mail. A sessão (token assinado pelo servidor,
   30 dias) fica neste navegador. Depois mostra pedidos com linha do tempo, rastreio e pagamento do restante. */
(function () {
  var raiz = document.querySelector('[data-glimmer-conta]');
  if (!raiz) { return; }

  var API = 'https://glimmer-checkout.vercel.app/api/conta';
  var CHAVE_SESSAO = 'glimmer_conta_sessao';
  var CHAVE_NOME = 'glimmer_conta_nome';   // primeiro nome: o site cumprimenta ("Olá, Ana") enquanto a sessão existir
  var CHAVE_EMAIL = 'glimmer_conta_email';
  var CHAVE_CONTATO = 'glimmer_conta_contato';
  var GOOGLE_ID = (raiz.getAttribute('data-google-id') || '').trim();
  var APPMAX_ID = (raiz.getAttribute('data-appmax-id') || '').trim();   // pagamento na página ligado (chave do Pagar.me)
  var PAGARME_PK = (raiz.getAttribute('data-pagarme-pk') || '').trim();
  var ASAAS = raiz.getAttribute('data-asaas') === '1';
  var camposCartao = raiz.querySelector('[data-adiantar-cartao]');   // campos do cartão (ficam fora da lista e entram no quadro)
  var adiantarDados = null;
  var envioDados = null;
  var pontosPorPedido = {};   // pedido -> { ganhos, a_liberar }      // envio com tudo chegado e pagamento na página (Appmax)
  var envioEndereco = null;   // endereço que vai ser usado (o do pedido ou o alterado)
  var appmaxIp = '';
  var esperaToken = null;
  var appmaxIniciado = false;
  var conferindoPix = null;

  var $ = function (s, el) { return (el || raiz).querySelector(s); };
  var passos = {
    entrar: $('[data-conta-passo="entrar"]'),
    codigo: $('[data-conta-passo="codigo"]'),
    pedidos: $('[data-conta-passo="pedidos"]')
  };
  var formContato = $('[data-conta-form-contato]');
  var campoContato = formContato.querySelector('[name="contato"]');
  var campoCodigo = passos.codigo.querySelector('[name="codigo"]');
  var aviso = $('[data-conta-aviso]');
  var carregando = $('[data-conta-carregando]');
  var ola = $('[data-conta-ola]');
  var contatoAtual = '';

  var ler = function (k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } };
  var gravar = function (k, v) { try { if (v) { localStorage.setItem(k, v); } else { localStorage.removeItem(k); } } catch (e) {} };

  function mostrar(nome) {
    Object.keys(passos).forEach(function (k) { passos[k].hidden = k !== nome; });
    raiz.classList.toggle('is-pedidos', nome === 'pedidos');
    var login = raiz.querySelector('[data-conta-login]');
    if (login) { login.hidden = nome === 'pedidos'; }
  }
  function erro(el, msg) { var e = el && el.querySelector('[data-conta-erro]'); if (e) { e.textContent = msg || ''; e.hidden = !msg; } }
  function avisar(msg, tipo) {
    aviso.textContent = msg || '';
    aviso.className = 'glimmer-conta__aviso' + (tipo ? ' glimmer-conta__aviso--' + tipo : '');
    aviso.hidden = !msg;
  }
  function ocupado(sim, botao) { carregando.hidden = !sim; if (botao) { botao.disabled = sim; } }
  function chamar(acao, opcoes) {
    opcoes = opcoes || {};
    var headers = { 'Content-Type': 'application/json' };
    var token = ler(CHAVE_SESSAO);
    if (token) { headers.Authorization = 'Bearer ' + token; }
    return fetch(API + '?acao=' + acao + (opcoes.query ? '&' + opcoes.query : ''), {
      method: opcoes.body ? 'POST' : 'GET', headers: headers, body: opcoes.body ? JSON.stringify(opcoes.body) : undefined
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { d._status = r.status; return d; }); });
  }
  function dinheiro(c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  function data(iso) { try { return new Date(iso).toLocaleDateString('pt-BR'); } catch (e) { return ''; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function cumprimentar(nome) {
    var t = $('[data-conta-titulo-ola]');
    if (t) { t.textContent = nome ? 'Olá, ' + nome + '!' : ''; t.hidden = !nome; }
  }
  function entrou(token, email, nome) {
    gravar(CHAVE_SESSAO, token);
    if (nome) { gravar(CHAVE_NOME, nome); cumprimentar(nome); }
    gravar(CHAVE_EMAIL, email || '');
    carregarPedidos();
  }
  function sair() {
    gravar(CHAVE_SESSAO, ''); gravar(CHAVE_EMAIL, ''); gravar(CHAVE_NOME, ''); cumprimentar('');
    try { if (window.google && google.accounts && google.accounts.id) { google.accounts.id.disableAutoSelect(); } } catch (e) {}
    ola.hidden = true; avisar(''); telaEntrar();
  }

  // --- Entrar com Google ---------------------------------------------------------
  function iniciarGoogle() {
    if (!GOOGLE_ID || !window.google || !google.accounts || !google.accounts.id) { return; }
    google.accounts.id.initialize({
      client_id: GOOGLE_ID,
      callback: function (resp) {
        ocupado(true);
        chamar('google', { body: { credential: resp.credential } }).then(function (d) {
          ocupado(false);
          if (d.ok && d.token) { entrou(d.token, d.email, d.nome); return; }
          avisar(d.error || 'Não foi possível entrar com o Google.', 'aviso');
        }).catch(function () { ocupado(false); avisar('Sem conexão. Tente novamente.', 'aviso'); });
      },
      ux_mode: 'popup',
      auto_select: false,
      cancel_on_tap_outside: true,
      use_fedcm_for_prompt: true
    });
    var alvo = $('[data-conta-google-botao]');
    if (!alvo) { return; }
    var provisorio = alvo.querySelector('[data-conta-google-provisorio]');
    if (provisorio) { provisorio.remove(); }
    google.accounts.id.renderButton(alvo, {
      type: 'standard', theme: 'outline', size: 'large', text: 'continue_with', shape: 'pill',
      logo_alignment: 'center', width: Math.min(400, alvo.clientWidth || alvo.parentNode.clientWidth || 320), locale: 'pt-BR'
    });
    var bloco = $('[data-conta-google]');
    if (bloco) { bloco.hidden = false; }
  }
  function carregarGoogle() {
    if (!GOOGLE_ID) { return; }
    // O script já vem na página (templates/search.conta.liquid): só espera ele terminar de carregar.
    var ja = document.getElementById('glimmer-gsi');
    if (ja) { ja.addEventListener('load', iniciarGoogle); return; }
    var s = document.createElement('script');
    s.id = 'glimmer-gsi'; s.src = 'https://accounts.google.com/gsi/client'; s.async = true; s.defer = true;
    s.onload = iniciarGoogle;
    document.head.appendChild(s);
  }
  function telaEntrar() {
    mostrar('entrar');
    if (window.google && google.accounts && google.accounts.id) { iniciarGoogle(); } else { carregarGoogle(); }
  }

  // --- Entrar com código ---------------------------------------------------------
  campoContato.value = ler(CHAVE_CONTATO);
  campoContato.addEventListener('input', function () {
    var v = campoContato.value;
    if (/^[\d\s()+-]+$/.test(v) && v.replace(/\D/g, '').length > 2) {
      var d = v.replace(/\D/g, '').replace(/^55(?=\d{10,11}$)/, '').slice(0, 11);
      campoContato.value = d.length > 10 ? d.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3') : d.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
    }
  });
  function pedirCodigo(botao, ondeErro) {
    var contato = campoContato.value.trim();
    erro(formContato, ''); erro(passos.codigo, '');
    if (!contato) { erro(formContato, 'Digite o e-mail ou o celular usado na compra.'); return; }
    ocupado(true, botao);
    chamar('codigo', { body: { contato: contato } }).then(function (d) {
      ocupado(false, botao);
      if (!d.ok) { erro(ondeErro || formContato, d.error || 'Não foi possível enviar o código.'); return; }
      contatoAtual = contato; gravar(CHAVE_CONTATO, contato);
      $('[data-conta-email]').textContent = d.email || 'seu e-mail';
      mostrar('codigo'); campoCodigo.focus();
    }).catch(function () { ocupado(false, botao); erro(ondeErro || formContato, 'Sem conexão. Tente novamente.'); });
  }
  formContato.addEventListener('submit', function (e) { e.preventDefault(); pedirCodigo(formContato.querySelector('button[type="submit"]')); });
  campoCodigo.addEventListener('input', function () { campoCodigo.value = campoCodigo.value.replace(/\D/g, '').slice(0, 6); });
  passos.codigo.addEventListener('submit', function (e) {
    e.preventDefault();
    var botao = passos.codigo.querySelector('button[type="submit"]');
    erro(passos.codigo, '');
    if (campoCodigo.value.length !== 6) { erro(passos.codigo, 'Digite os 6 dígitos do código.'); return; }
    ocupado(true, botao);
    chamar('entrar', { body: { contato: contatoAtual, codigo: campoCodigo.value } }).then(function (d) {
      ocupado(false, botao);
      if (!d.ok || !d.token) { erro(passos.codigo, d.error || 'Código inválido.'); return; }
      campoCodigo.value = '';
      entrou(d.token, d.email);
    }).catch(function () { ocupado(false, botao); erro(passos.codigo, 'Sem conexão. Tente novamente.'); });
  });
  $('[data-conta-reenviar]').addEventListener('click', function (e) { campoContato.value = contatoAtual || campoContato.value; pedirCodigo(e.currentTarget, passos.codigo); });
  $('[data-conta-trocar]').addEventListener('click', function () { telaEntrar(); campoContato.focus(); });
  $('[data-conta-sair]').addEventListener('click', sair);

  // --- Pedidos ---------------------------------------------------------------------
  var SITUACAO = {
    'aguardando-chegada': { rotulo: 'Aguardando chegada', classe: 'espera', texto: 'Seu produto está a caminho da Glimmer. Você pode pagar o restante agora ou quando ele chegar.' },
    'chegou-pagar': { rotulo: 'Chegou! Pague o restante', classe: 'acao', texto: 'Seu produto chegou na Glimmer. Pague o restante para enviarmos o pedido.' },
    'pago': { rotulo: 'Pago', classe: 'ok', texto: 'Pagamento confirmado. Estamos preparando o envio.' },
    'enviado': { rotulo: 'Enviado', classe: 'ok', texto: 'Seu pedido está a caminho.' },
    'entregue': { rotulo: 'Entregue', classe: 'ok', texto: 'Pedido entregue. Aproveite!' },
    'em-analise': { rotulo: 'Em análise', classe: 'espera', texto: 'Estamos conferindo o pagamento. Se precisarmos de algo, falamos com você pelo WhatsApp.' },
    'aguardando-pagamento': { rotulo: 'Aguardando pagamento', classe: 'espera', texto: '' },
    'cancelado': { rotulo: 'Cancelado', classe: 'neutro', texto: '' }
  };
  function linhaDoTempo(passosPedido) {
    var lista = passosPedido || [];
    var feitos = lista.filter(function (p) { return p.estado === 'feito'; }).length;
    // A linha colorida vai do primeiro passo até o passo atual.
    var ate = lista[feitos] ? feitos : lista.length - 1;
    var pct = lista.length > 1 ? (ate / (lista.length - 1)).toFixed(3) : 0;
    return '<ol class="gp-tempo" style="--gp-n:' + Math.max(1, lista.length) + ';--gp-progresso:' + pct + '">' + lista.map(function (p) {
      return '<li class="is-' + esc(p.estado) + '"><span class="gp-tempo__ponto" aria-hidden="true"></span><span class="gp-tempo__nome">' + esc(p.titulo) + '</span></li>';
    }).join('') + '</ol>';
  }
  // --- Rastreio: prévia do último status + janela com o histórico ---------------------
  var rastreiosGuardados = [];
  function dataHora(iso) {
    try { var d = new Date(iso); return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) + ' às ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }); } catch (e) { return ''; }
  }
  var ICONE_CAMINHAO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  function rastreio(rs) {
    if (!rs || !rs.length) { return ''; }
    return rs.map(function (r) {
      var n = rastreiosGuardados.push(r) - 1;
      var u = r.ultimo || {};
      var linha = [r.empresa, u.local, u.data ? dataHora(u.data) : ''].filter(Boolean).join(' · ');
      return '<div class="gp-rastreio gp-rastreio--' + esc(u.tipo || 'normal') + '">' +
        '<span class="gp-rastreio__icone">' + ICONE_CAMINHAO + '</span>' +
        '<span class="gp-rastreio__texto"><strong>' + esc(u.titulo || 'Enviado') + '</strong><small>' + esc(linha) + '</small>' +
          (r.previsao && !r.entregue ? '<small>Previsão: ' + data(r.previsao) + '</small>' : '') + '</span>' +
        '<button type="button" class="gp-rastreio__botao" data-rastreio="' + n + '">Rastrear</button>' +
      '</div>';
    }).join('');
  }
  var janela = null;
  function abrirRastreio(n) {
    var r = rastreiosGuardados[n];
    if (!r) { return; }
    if (!janela) {
      janela = document.createElement('div');
      janela.className = 'glimmer-rastreio-janela';
      janela.setAttribute('role', 'dialog');
      janela.setAttribute('aria-modal', 'true');
      janela.innerHTML = '<div class="glimmer-rastreio-janela__fundo" data-fechar></div><div class="glimmer-rastreio-janela__caixa"><button type="button" class="glimmer-rastreio-janela__fechar" data-fechar aria-label="Fechar">&times;</button><div data-conteudo></div></div>';
      document.body.appendChild(janela);
      janela.addEventListener('click', function (e) {
        if (e.target.closest('[data-fechar]')) { fecharRastreio(); }
        var c = e.target.closest('[data-copiar]');
        if (c) { try { navigator.clipboard.writeText(c.getAttribute('data-copiar')); c.textContent = 'Copiado!'; setTimeout(function () { c.textContent = 'Copiar'; }, 1500); } catch (er) {} }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { fecharRastreio(); } });
    }
    var eventos = (r.eventos && r.eventos.length) ? r.eventos : [r.ultimo || { titulo: 'Enviado' }];
    janela.querySelector('[data-conteudo]').innerHTML =
      '<h2 class="glimmer-rastreio-janela__titulo">Rastreio do pedido</h2>' +
      '<div class="glimmer-rastreio-janela__codigo"><span><small>' + esc(r.empresa) + '</small><strong>' + esc(r.codigo || '—') + '</strong></span>' +
        (r.codigo ? '<button type="button" class="glimmer-conta__link" data-copiar="' + esc(r.codigo) + '">Copiar</button>' : '') + '</div>' +
      (r.previsao && !r.entregue ? '<p class="glimmer-rastreio-janela__previsao">Previsão de entrega: <strong>' + data(r.previsao) + '</strong></p>' : '') +
      '<ol class="glimmer-rastreio-janela__lista">' + eventos.map(function (e, i) {
        return '<li class="' + (i === 0 ? 'is-atual ' : '') + 'is-' + esc(e.tipo || 'normal') + '"><span class="glimmer-rastreio-janela__ponto" aria-hidden="true"></span><span>' +
          '<strong>' + esc(e.titulo) + '</strong>' +
          (e.mensagem ? '<span class="glimmer-rastreio-janela__msg">' + esc(e.mensagem) + '</span>' : '') +
          '<small>' + esc([e.local, e.data ? dataHora(e.data) : ''].filter(Boolean).join(' · ')) + '</small></span></li>';
      }).join('') + '</ol>' +
      (r.link ? '<a class="glimmer-co__botao glimmer-rastreio-janela__site" href="' + esc(r.link) + '" target="_blank" rel="noopener">Abrir no site da transportadora</a>' : '');
    janela.classList.add('is-aberta');
    document.documentElement.classList.add('glimmer-sem-rolagem');
  }
  function fecharRastreio() {
    if (!janela) { return; }
    janela.classList.remove('is-aberta');
    document.documentElement.classList.remove('glimmer-sem-rolagem');
  }

  function dataLonga(iso) {
    try { return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ de /g, ' ').replace('.', ''); } catch (e) { return data(iso); }
  }
  // "Marca - Tipo - Nome" (padrão dos produtos importados) -> marca em cima, nome embaixo.
  function partesTitulo(t) {
    var p = String(t || '').split(' - ');
    if (p.length >= 3) { return { marca: p[0], nome: p.slice(2).join(' - ') }; }
    if (p.length === 2) { return { marca: p[0], nome: p[1] }; }
    return { marca: '', nome: t };
  }
  // Barrinha de etapas (curta); a linha do tempo com os nomes fica em "Ver detalhes".
  function progresso(passosPedido) {
    var lista = passosPedido || [];
    if (!lista.length) { return ''; }
    var feitos = lista.filter(function (x) { return x.estado === 'feito'; }).length;
    var pct = Math.round(100 * Math.min(feitos, lista.length) / lista.length);
    var atual = lista.filter(function (x) { return x.estado === 'atual'; })[0];
    return '<div class="gp-prog2"><div class="gp-prog2__barra"><span style="width:' + Math.max(8, pct) + '%"></span></div>' +
      '<span class="gp-prog2__txt">' + (atual ? 'Próxima etapa: <strong>' + esc(atual.titulo) + '</strong>' : '<strong>Concluído</strong>') + ' · ' + feitos + ' de ' + lista.length + '</span></div>';
  }
  function cartao(p) {
    var s = SITUACAO[p.situacao] || SITUACAO['aguardando-pagamento'];
    // Frete na chegada: o restante e o frete são pagos juntos no "Seu envio".
    if (p.frete_na_chegada && (p.situacao === 'aguardando-chegada' || p.situacao === 'chegou-pagar')) {
      s = {
        rotulo: p.situacao === 'aguardando-chegada' ? 'A caminho da Glimmer' : 'Chegou na Glimmer',
        classe: p.situacao === 'aguardando-chegada' ? 'espera' : 'acao',
        texto: p.situacao === 'aguardando-chegada'
          ? 'Vai junto com seus outros pedidos, num envio só.'
          : 'Já chegou! O frete' + (p.restante > 0 ? ' e o restante' : '') + ' são pagos juntos em "Seu envio".'
      };
    }
    var itensLista = p.itens || [];
    var qtd = itensLista.reduce(function (t, i) { return t + (i.quantidade || 0); }, 0);
    var comFoto = itensLista.filter(function (i) { return i.imagem; });
    var miniaturas = comFoto.length ? '<div class="gp-minis">' + comFoto.slice(0, 4).map(function (i) { return '<img src="' + esc(i.imagem) + '" alt="" loading="lazy">'; }).join('') +
      (itensLista.length > 4 ? '<span class="gp-minis__mais">+' + (itensLista.length - 4) + '</span>' : '') + '</div>' : '';
    var primeiro = itensLista[0] ? partesTitulo(itensLista[0].titulo) : null;
    var resumoItens = primeiro ? esc(primeiro.nome) + (itensLista.length > 1 ? ' <span>e mais ' + (itensLista.length - 1) + '</span>' : '') : '';
    var itens = itensLista.map(function (i) {
      var t = partesTitulo(i.titulo);
      return '<li class="gp-item">' + (i.imagem ? '<img src="' + esc(i.imagem) + '" alt="" loading="lazy">' : '<span class="gp-item__foto"></span>') +
        '<span class="gp-item__texto">' + (t.marca ? '<small class="gp-item__marca">' + esc(t.marca) + '</small>' : '') +
        '<strong class="gp-item__nome">' + esc(t.nome) + '</strong>' +
        '<small class="gp-item__info">' + [i.variante ? esc(i.variante) : '', i.quantidade + (i.quantidade > 1 ? ' unidades' : ' unidade')].filter(Boolean).join(' · ') + '</small></span></li>';
    }).join('');
    var falta = p.restante > 0 && p.metade;
    var pp = pontosPorPedido[p.pedido];
    var detalhesValores = '<div class="gp-linha"><span>Total do pedido</span><span>' + dinheiro(p.total) + '</span></div>' +
      (p.metade ? '<div class="gp-linha"><span>Já pago</span><span>' + dinheiro(p.pago) + '</span></div>' : '') +
      (falta ? '<div class="gp-linha is-falta"><span>Falta pagar</span><span>' + dinheiro(p.restante) + '</span></div>' : '') +
      (pp && (pp.ganhos > 0 || pp.a_liberar > 0) ? '<div class="gp-linha is-pontos"><span>Pontos</span><span>+' + pp.ganhos + (pp.a_liberar > 0 ? ' agora · +' + pp.a_liberar + ' ao pagar o restante' : '') + '</span></div>' : '');
    var botoes = (emAdiantar(p.pedido)
        ? '<button type="button" class="gp-botao gp-botao--pequeno" data-adiantar-um="' + esc(p.pedido) + '">Pagar o restante</button>'
        : '') +
      (p.pode_pagar && !emAdiantar(p.pedido)
        ? '<button type="button" class="gp-botao gp-botao--pequeno" data-pagar="' + esc(p.pedido) + '" data-metodo="cartao">Pagar ' + dinheiro(p.restante_cartao || p.restante) + '</button>'
        : '');
    return '<article class="gp-pedido' + (p.situacao === 'chegou-pagar' ? ' is-destaque' : '') + (p.situacao === 'cancelado' ? ' is-cancelado' : '') + '">' +
      '<header class="gp-pedido__cabeca">' +
        '<div><h3 class="gp-pedido__numero">Pedido ' + esc(p.pedido) + '</h3>' +
          '<span class="gp-pedido__data">' + dataLonga(p.data) + (qtd ? ' · ' + qtd + (qtd > 1 ? ' itens' : ' item') : '') + '</span></div>' +
        '<span class="gp-selo gp-selo--' + s.classe + '">' + s.rotulo + '</span></header>' +
      miniaturas +
      (resumoItens ? '<p class="gp-pedido__itens">' + resumoItens + '</p>' : '') +
      (p.situacao !== 'cancelado' ? linhaDoTempo(p.passos) : '') +
      (s.texto ? '<p class="gp-pedido__situacao">' + s.texto + '</p>' : '') +
      rastreio(p.rastreios) +
      '<footer class="gp-pedido__rodape">' +
        '<div class="gp-pedido__valor">' + (falta
          ? '<small>Falta pagar</small><strong class="is-falta">' + dinheiro(p.restante) + '</strong>'
          : '<small>Total</small><strong>' + dinheiro(p.total) + '</strong>') + '</div>' +
        (botoes ? '<div class="gp-pedido__acoes">' + botoes + '</div>' : '') +
      '</footer>' +
      '<details class="gp-detalhes"><summary><span class="gp-detalhes__ver">Ver detalhes</span><span class="gp-detalhes__esconder">Esconder detalhes</span></summary><div class="gp-detalhes__corpo">' +
        '<ul class="gp-itens">' + itens + '</ul>' +
        '<div class="gp-detalhes__valores">' + detalhesValores + '</div>' +
      '</div></details>' +
      '</article>';
  }
  // --- Pagar o restante agora (Appmax): um ou mais pedidos juntos, no Pix ou no cartão ---
  // O restante de cada pedido não tem taxa de cartão (vale para entrada paga no Pix ou no cartão):
  // no Pix paga a soma; no cartão, a soma ÷ fator da parcela (tabela do cartão: 1x a 6x mesmo valor, 7x a 12x com juros).
  function emAdiantar(nome) { return Boolean(adiantarDados && adiantarDados.pedidos.some(function (x) { return x.pedido === nome; })); }
  function cartao50(c, n, t) {
    t = t || adiantarDados || (envioDados && envioDados.appmax);
    if (t.fatores && t.fatores.length) {
      var f50 = t.fatores[Math.max(1, Math.min(12, n)) - 1];
      return Math.round(Math.round(c) / (f50 > 0 && f50 < 1 ? f50 : 1));
    }
    if (t.fator) {
      var f = n <= 6 ? t.fator : (t.fatores_juros || [])[n - 7];
      return Math.round(Math.round(c) / (f > 0 && f < 1 ? f : t.fator));
    }
    var umaVez = Math.round(Math.round(c) * (1 + t.taxa_1x / 100));
    return Math.round(umaVez * (1 + (t.taxa_parcela / 100) * (n - 1)));
  }
  function cartaoAdiantar(a) {
    if (!a || !a.pedidos.length) { return ''; }
    var varios = a.pedidos.length > 1;
    var falta = a.pedidos.reduce(function (t, x) { return t + x.restante; }, 0);
    var lista = a.pedidos.map(function (x) {
      return '<li><label class="gp-check' + (varios ? '' : ' is-unico') + '"><input type="checkbox" name="adiantar-pedido" value="' + esc(x.pedido) + '" data-restante="' + x.restante + '" checked' + (varios ? '' : ' hidden') + '>' +
        '<span class="gp-check__caixa" aria-hidden="true"></span><span class="gp-check__nome">Pedido ' + esc(x.pedido) + '</span><strong>' + dinheiro(x.restante) + '</strong></label></li>';
    }).join('');
    var metodo = function (valor, nome, info, marcado) {
      return '<label class="gp-metodo"><input type="radio" name="adiantar-metodo" value="' + valor + '"' + (marcado ? ' checked' : '') + '>' +
        '<span class="gp-metodo__nome">' + nome + '</span><span class="gp-metodo__valor" data-adiantar-valor="' + valor + '"></span><span class="gp-metodo__info">' + info + '</span></label>';
    };
    var aberto = window.matchMedia && window.matchMedia('(min-width: 960px)').matches;
    return '<section class="gp-bloco gp-adiantar" data-adiantar>' +
      '<button type="button" class="gp-adiantar__resumo" data-adiantar-abrir aria-expanded="' + (aberto ? 'true' : 'false') + '">' +
        '<span class="gp-adiantar__rotulo"><small>Falta pagar</small><strong>' + dinheiro(falta) + '</strong>' +
        '<em>' + (varios ? a.pedidos.length + ' pedidos · ' : '') + 'pague agora e, na chegada, fica só o frete</em></span>' +
        '<span class="gp-adiantar__abrir">Pagar</span></button>' +
      '<div class="gp-adiantar__corpo" data-adiantar-corpo' + (aberto ? '' : ' hidden') + '>' +
        (varios ? '<p class="gp-bloco__dica">Escolha o que quer pagar agora:</p>' : '') +
        '<ul class="gp-checks">' + lista + '</ul>' +
        '<div class="gp-metodos" role="radiogroup" aria-label="Forma de pagamento">' + metodo('pix', 'Pix', 'aprovação na hora', true) + metodo('cartao', 'Cartão', 'até ' + (a.parcelas_max || 12) + 'x', false) + '</div>' +
        '<div data-adiantar-cartao-lugar></div>' +
        '<div class="gp-total"><span>Total a pagar</span><strong data-adiantar-total></strong></div>' +
        '<p class="glimmer-co__erro" data-adiantar-erro role="alert" hidden></p>' +
        '<button type="button" class="gp-botao gp-botao--cheio" data-adiantar-pagar></button>' +
        '<div class="glimmer-co__pix" data-adiantar-pix hidden></div>' +
        '<p class="gp-seguro">Pagamento seguro: cartão pelo ' + (ASAAS ? 'Asaas' : 'Pagar.me') + ' e Pix pelo Mercado Pago</p>' +
      '</div>' +
      '</section>';
  }
  function abrirAdiantar(sim) {
    var c = caixaAdiantar();
    if (!c) { return; }
    c.querySelector('[data-adiantar-abrir]').setAttribute('aria-expanded', sim ? 'true' : 'false');
    c.querySelector('[data-adiantar-corpo]').hidden = !sim;
  }
  function caixaAdiantar() { return passos.pedidos.querySelector('[data-adiantar]'); }
  function marcadosAdiantar() {
    var c = caixaAdiantar();
    return c ? [].slice.call(c.querySelectorAll('input[name="adiantar-pedido"]:checked')) : [];
  }
  function parcelasAdiantar() { var s = camposCartao && camposCartao.querySelector('[data-adiantar-parcelas]'); return s ? Math.max(1, parseInt(s.value, 10) || 1) : 1; }
  function atualizarAdiantar() {
    var c = caixaAdiantar();
    if (!c) { return; }
    var soma = marcadosAdiantar().reduce(function (s, el) { return s + parseInt(el.getAttribute('data-restante'), 10); }, 0);
    var metodo = (c.querySelector('input[name="adiantar-metodo"]:checked') || {}).value || 'pix';
    var sel = camposCartao && camposCartao.querySelector('[data-adiantar-parcelas]');
    if (sel) {
      var atual = parcelasAdiantar(), html = '';
      for (var i = 1; i <= (adiantarDados.parcelas_max || 12); i++) {
        var t = cartao50(soma, i);
        if (i > 1 && Math.floor(t / i) < 500) { break; }   // parcela mínima da Appmax: R$ 5,00
        html += '<option value="' + i + '"' + (i === atual ? ' selected' : '') + '>' + (i === 1 ? '1x de ' + dinheiro(t) + ' (à vista)' : i + 'x de ' + dinheiro(Math.floor(t / i)) + ' · total ' + dinheiro(t)) + '</option>';
      }
      sel.innerHTML = html;
    }
    if (camposCartao) { camposCartao.hidden = metodo !== 'cartao'; }
    var total = metodo === 'cartao' ? cartao50(soma, parcelasAdiantar()) : soma;
    c.querySelector('[data-adiantar-valor="pix"]').textContent = dinheiro(soma);
    c.querySelector('[data-adiantar-valor="cartao"]').textContent = 'a partir de ' + dinheiro(cartao50(soma, 1));
    c.querySelector('[data-adiantar-total]').textContent = dinheiro(total);
    var botao = c.querySelector('[data-adiantar-pagar]');
    botao.disabled = !soma;
    botao.textContent = !soma ? 'Marque um pedido' : (metodo === 'cartao' ? 'Pagar ' + dinheiro(total) + ' no cartão' : 'Gerar Pix de ' + dinheiro(total));
  }
  function erroAdiantar(msg) { var e = caixaAdiantar() && caixaAdiantar().querySelector('[data-adiantar-erro]'); if (e) { e.textContent = msg || ''; e.hidden = !msg; } }
  // Pagar.me: o cartão vira um token aqui no navegador (chave pública); o número nunca passa pelo nosso servidor.
  function tokenPagarme(pk, num, nome, mes, ano, cvv) {
    return fetch('https://api.pagar.me/core/v5/tokens?appId=' + encodeURIComponent(pk), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: 'card', card: { number: num, holder_name: nome, exp_month: parseInt(mes, 10), exp_year: parseInt(ano, 10), cvv: cvv } })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (x) {
        if (x.ok && x.d && x.d.id) { return x.d.id; }
        throw new Error('token');
      });
  }
  function iniciarAppmax() {
    if (appmaxIniciado || !APPMAX_ID || !camposCartao) { return; }
    if (ASAAS || PAGARME_PK) { appmaxIniciado = true; return; }   // cartão pelo Asaas/Pagar.me (sem o script da Appmax)
    if (!window.AppmaxScripts) { setTimeout(iniciarAppmax, 300); return; }
    appmaxIniciado = true;
    var f = document.getElementById('glimmer-appmax-form');
    if (f) { f.addEventListener('submit', function (e) { e.preventDefault(); }); }
    window.AppmaxScripts.init({
      externalId: APPMAX_ID,
      onIp: function (r) { appmaxIp = (r && r.ip) || ''; },
      onTokenize: function (r) { if (esperaToken) { esperaToken.ok(r && r.token); esperaToken = null; } },
      onError: function (err) {
        if (esperaToken && (!err || err.stage !== 'ip')) { esperaToken.falha('Não conseguimos validar o cartão. Confira os dados e tente de novo.'); esperaToken = null; }
      }
    });
  }
  function tokenizarCartao() {
    var digitos = function (v) { return String(v || '').replace(/\D/g, ''); };
    var get = function (n) { return camposCartao.querySelector('[name="' + n + '"]'); };
    var num = digitos(get('card-number').value), mes = digitos(get('exp-month').value), ano = digitos(get('exp-year').value), cvv = digitos(get('cvv').value);
    if (num.length < 13) { return Promise.reject('Confira o número do cartão.'); }
    if (!get('card-holder-name').value.trim()) { return Promise.reject('Informe o nome impresso no cartão.'); }
    if (!(parseInt(mes, 10) >= 1 && parseInt(mes, 10) <= 12)) { return Promise.reject('Confira o mês de validade do cartão.'); }
    if (ano.length === 2) { ano = '20' + ano; }
    if (ano.length !== 4) { return Promise.reject('Confira o ano de validade do cartão.'); }
    if (cvv.length < 3) { return Promise.reject('Confira o CVV do cartão.'); }
    get('card-number').value = num; get('exp-month').value = ('0' + mes).slice(-2); get('exp-year').value = ano; get('cvv').value = cvv;
    // Asaas: não tem token no navegador; os dados vão por HTTPS para o nosso servidor, que repassa na hora (sem guardar).
    if (ASAAS) { return Promise.resolve({ numero: num, nome: get('card-holder-name').value.trim(), mes: ('0' + mes).slice(-2), ano: ano, cvv: cvv }); }
    if (PAGARME_PK) {
      return tokenPagarme(PAGARME_PK, num, get('card-holder-name').value.trim(), mes, ano, cvv)
        .catch(function () { throw 'Não conseguimos validar o cartão. Confira os dados e tente de novo.'; });
    }
    var f = document.getElementById('glimmer-appmax-form');
    if (!window.AppmaxScripts || !f) { return Promise.reject('O pagamento por cartão ainda está carregando. Tente de novo em alguns segundos.'); }
    return new Promise(function (ok, falha) {
      esperaToken = { ok: ok, falha: falha };
      setTimeout(function () { if (esperaToken) { esperaToken.falha('O cartão demorou para responder. Tente de novo.'); esperaToken = null; } }, 20000);
      if (f.requestSubmit) { f.requestSubmit(); } else { f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    });
  }
  function conferirAdiantamento(id, tentativa) {
    conferindoPix = id;
    chamar('adiantar-status', { query: 'id=' + encodeURIComponent(id) }).then(function (d) {
      if (conferindoPix !== id) { return; }
      if (d.status === 'pago') { conferindoPix = null; avisar('Restante pago! ' + ((d.pedidos || []).length > 1 ? 'Os pedidos ' : 'O pedido ') + (d.pedidos || []).join(', ') + ' já está' + ((d.pedidos || []).length > 1 ? 'ão' : '') + ' quitado' + ((d.pedidos || []).length > 1 ? 's' : '') + '. Quando chegar, fica só o frete.', 'ok'); carregarPedidos(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      if (d.status === 'em-analise') { conferindoPix = null; avisar('Recebemos seu pagamento e estamos conferindo. Falaremos com você se precisarmos de algo.', 'aviso'); carregarPedidos(); return; }
      if (d.status === 'recusado') { conferindoPix = null; erroAdiantar('O pagamento não foi aprovado. Tente de novo.'); return; }
      if (tentativa < 180) { setTimeout(function () { conferirAdiantamento(id, tentativa + 1); }, 5000); }
    }).catch(function () { if (tentativa < 180 && conferindoPix === id) { setTimeout(function () { conferirAdiantamento(id, tentativa + 1); }, 5000); } });
  }
  // Pix: o nome do recebedor (campo 59 do código copia e cola) é o que o app do banco mostra na hora de pagar.
  // Mostrando antes, o cliente não estranha um nome diferente de "Glimmer".
  function recebedorPix(emv) {
    var s = String(emv || ''), i = 0;
    while (i + 4 <= s.length) {
      var id = s.substr(i, 2), n = parseInt(s.substr(i + 2, 2), 10);
      if (!(n >= 0)) { return ''; }
      if (id === '59') { return s.substr(i + 4, n).trim(); }
      i += 4 + n;
    }
    return '';
  }
  function avisoRecebedorPix(emv, nomeFixo) {
    var nome = nomeFixo || recebedorPix(emv);
    if (!nome) { return ''; }
    // Nome com CNPJ na frente (ex.: "66.772.367 Lara ..."): é o CNPJ da própria loja.
    var seguro = /glimmer/i.test(nome) ? '' : (/^\d{2}\.\d{3}\.\d{3}/.test(nome) ? ' Pode pagar tranquilo: é o CNPJ responsável pela Glimmer.' : ' Pode pagar tranquilo: é a empresa que processa os pagamentos da Glimmer com segurança.');
    return '<p class="glimmer-co__pix-recebedor">No app do banco, o Pix vai aparecer para <strong>' + nome.replace(/[&<>"]/g, '') + '</strong>.' + seguro + '</p>';
  }
  function mostrarPixAdiantar(pix, id) {
    var caixa = caixaAdiantar() && caixaAdiantar().querySelector('[data-adiantar-pix]');
    if (!caixa) { return; }
    var img = pix.qr_code ? (/^data:|^https?:/.test(pix.qr_code) ? pix.qr_code : 'data:image/png;base64,' + pix.qr_code) : '';
    caixa.innerHTML = '<p class="glimmer-co__pix-titulo">Pague com Pix</p>' +
      (img ? '<img class="glimmer-co__pix-qr" alt="QR code do Pix" src="' + img + '">' : '') +
      '<label class="glimmer-co__campo glimmer-co__campo--inteiro"><span>Pix copia e cola</span><input type="text" readonly data-adiantar-pix-codigo></label>' +
      '<button type="button" class="glimmer-co__botao glimmer-co__botao--leve" data-adiantar-pix-copiar>Copiar código</button>' +
      avisoRecebedorPix(pix.copia_e_cola, pix.recebedor) +
      '<p class="glimmer-co__ajuda">Aguardando o pagamento... assim que o Pix for confirmado, esta página atualiza sozinha.</p>';
    caixa.querySelector('[data-adiantar-pix-codigo]').value = pix.copia_e_cola || '';
    caixa.hidden = false;
    caixa.scrollIntoView({ behavior: 'smooth', block: 'center' });
    conferirAdiantamento(id, 0);
  }
  function pagarAdiantar(botao) {
    var c = caixaAdiantar();
    var nomes = marcadosAdiantar().map(function (el) { return el.value; });
    if (!nomes.length) { erroAdiantar('Marque um pedido.'); return; }
    var metodo = (c.querySelector('input[name="adiantar-metodo"]:checked') || {}).value || 'pix';
    erroAdiantar('');
    ocupado(true, botao);
    var preparar = metodo === 'cartao' ? tokenizarCartao() : Promise.resolve('');
    preparar.then(function (token) {
      var titular = metodo === 'cartao' ? camposCartao.querySelector('[name="card-holder-name"]').value.trim() : '';
      return chamar('adiantar', { body: { pedidos: nomes, metodo: metodo, appmax: { token: token || '', parcelas: metodo === 'cartao' ? parcelasAdiantar() : 1, ip: appmaxIp, titular: titular } } });
    }).then(function (d) {
      ocupado(false, botao);
      if (d._status === 401) { gravar(CHAVE_SESSAO, ''); telaEntrar(); avisar('Sua sessão expirou. Entre de novo.', 'aviso'); return; }
      if (!d.ok) { erroAdiantar(d.error || 'Não foi possível gerar o pagamento.'); return; }
      if (d.pix) {
        botao.disabled = true; botao.textContent = 'Aguardando o Pix...';
        c.querySelectorAll('input').forEach(function (el) { el.disabled = true; });
        mostrarPixAdiantar(d.pix, d.id);
        return;
      }
      if (d.status === 'pago') { avisar('Restante pago no cartão! Quando chegar, fica só o frete.', 'ok'); carregarPedidos(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      botao.disabled = true; botao.textContent = 'Confirmando o pagamento...';
      var notaA = caixaAdiantar() && caixaAdiantar().querySelector('[data-adiantar-pix]');
      if (notaA) { notaA.innerHTML = '<p class="glimmer-co__ajuda"><strong>Pagamento no cartão enviado!</strong> A operadora está confirmando. Costuma levar até 2 minutos e esta página atualiza sozinha. Pode sair: avisamos por WhatsApp e e-mail.</p>'; notaA.hidden = false; }
      conferirAdiantamento(d.id, 0);
    }).catch(function (msg) {
      ocupado(false, botao);
      erroAdiantar(typeof msg === 'string' ? msg : 'Sem conexão. Tente novamente.');
    });
  }

  // --- Pontos: 1 ponto por R$ 1 do valor base dos produtos; valem 3 meses ---
  function cartaoPontos(pt) {
    if (!pt) { return ''; }
    return '<a class="gp-pontos-mini" href="/search?view=pontos">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.1 1.2-6.5-4.8-4.6 6.6-.9z"/></svg>' +
      '<span><strong>' + (pt.saldo || 0).toLocaleString('pt-BR') + '</strong> pontos' + (pt.a_liberar > 0 ? ' <small>· +' + pt.a_liberar.toLocaleString('pt-BR') + ' a liberar</small>' : '') + '</span></a>';
  }

  // --- Envio único (frete na chegada): todos os pedidos vão juntos; frete + restantes pagos de uma vez ---
  var ICONE_CAIXA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="m3 7.5 9 4.5 9-4.5M12 12v9"/></svg>';
  function cartaoEnvio(e) {
    if (!e) { return ''; }
    var chips = '<ul class="gp-chips">' + e.pedidos.map(function (n) { return '<li>' + esc(n) + '</li>'; }).join('') + '</ul>';
    var topo = function (titulo, sub) {
      return '<div class="gp-bloco__topo"><span class="gp-icone">' + ICONE_CAIXA + '</span><div><h2 class="gp-bloco__titulo">' + titulo + '</h2><p class="gp-bloco__sub">' + sub + '</p></div></div>';
    };
    if (!e.todos_chegaram) { return ''; }
    var opcoes = (e.opcoes || []);
    if (opcoes.length && e.appmax && e.endereco && APPMAX_ID && camposCartao) { return envioPronto(e, topo, chips); }
    if (!opcoes.length) {
      return '<section class="gp-bloco gp-envio is-destaque">' + topo('Tudo chegou! 🎉', 'Não conseguimos calcular o frete agora') +
        '<p class="gp-bloco__dica">Recarregue a página em alguns minutos ou fale com a gente pelo WhatsApp.</p></section>';
    }
    var linhas = opcoes.map(function (o, i) {
      return '<li><label class="glimmer-co__opcao"><input type="radio" name="envio-frete" value="' + esc(o.nome) + '"' + (i === 0 ? ' checked' : '') + ' data-total="' + o.total + '" data-total-cartao="' + o.total_cartao + '" data-frete="' + o.valor + '">' +
        '<span class="glimmer-co__dot" aria-hidden="true"></span><span class="glimmer-co__opcao-nome">' + esc(o.nome) + '</span>' +
        '<span class="glimmer-co__opcao-info">' + (o.prazo_dias ? 'até ' + o.prazo_dias + ' dias úteis' : '') + '</span>' +
        '<span class="glimmer-co__opcao-valor">' + dinheiro(o.valor) + '</span></label></li>';
    }).join('');
    return '<section class="gp-bloco gp-envio is-destaque" data-envio>' +
      topo(e.total > 1 ? 'Seus pedidos chegaram! 🎉' : 'Seu pedido chegou! 🎉', 'Escolha o frete' + (e.restante > 0 ? ' e pague junto o restante' : '') + (e.cidade ? ' · ' + esc(e.cidade) : '')) +
      chips +
      '<ul class="glimmer-co__opcoes">' + linhas + '</ul>' +
      (e.restante > 0 ? '<div class="gp-linha"><span>Restante dos pedidos</span><span>' + dinheiro(e.restante) + '</span></div>' : '') +
      '<div class="gp-linha"><span>Frete</span><span data-envio-frete></span></div>' +
      '<div class="gp-total"><span>Total no cartão</span><strong data-envio-total></strong></div>' +
      '<button type="button" class="gp-botao gp-botao--cheio" data-pagar-envio>Pagar no cartão</button>' +
      '<p class="gp-seguro">' + (e.tem50 ? 'Valor em 1x; parcelado tem juros' : 'Em até 6x sem juros') + '</p>' +
      '</section>';
  }
  function faixaEnvio(e) {
    if (!e || e.todos_chegaram) { return ''; }
    return '<div class="gp-faixa">' +
      '<span class="gp-faixa__icone">' + ICONE_CAIXA + '</span>' +
      '<span class="gp-faixa__texto"><strong>' + e.chegaram + ' de ' + e.total + (e.total > 1 ? ' pedidos chegaram' : ' pedido chegou') + ' na Glimmer</strong>' +
        '<small>' + (e.total > 1 ? 'Vão juntos, num envio só. ' : '') + 'Quando ' + (e.total > 1 ? 'todos chegarem' : 'chegar') + ', avisamos para você escolher o frete.</small>' +
        '<span class="gp-barra"><span style="width:' + Math.max(6, Math.round(100 * e.chegaram / e.total)) + '%"></span></span></span>' +
    '</div>';
  }
  // --- Tudo chegou: 1) frete, 2) endereço (pode alterar), 3) pagamento (Pix ou cartão, Appmax) ---
  function textoEnvio(e) {
    var varios = e.total > 1;
    // O título já diz que chegou: aqui fica só o que falta.
    if (e.restante > 0) {
      return 'Para enviarmos' + (varios ? ' tudo junto' : '') + ', só falta pagar o <strong>restante de ' + dinheiro(e.restante) + '</strong> e o <strong>frete</strong>.';
    }
    return (varios ? 'Eles já estão pagos.' : 'Ele já está pago.') + ' Para enviarmos' + (varios ? ' tudo junto' : '') + ', só falta o <strong>frete</strong>.';
  }
  function opcoesFreteHtml(opcoes, marcado) {
    var tem = opcoes.some(function (o) { return o.nome === marcado; });
    return opcoes.map(function (o, i) {
      var sel = tem ? o.nome === marcado : i === 0;
      return '<li><label class="glimmer-co__opcao"><input type="radio" name="envio-frete" value="' + esc(o.nome) + '"' + (sel ? ' checked' : '') + ' data-frete="' + o.valor + '">' +
        '<span class="glimmer-co__dot" aria-hidden="true"></span><span class="glimmer-co__opcao-nome">' + esc(o.nome) + '</span>' +
        '<span class="glimmer-co__opcao-info">' + (o.prazo_dias ? 'até ' + o.prazo_dias + ' dias úteis' : '') + '</span>' +
        '<span class="glimmer-co__opcao-valor">' + dinheiro(o.valor) + '</span>' +
        (envioDados && envioDados.appmax ? '<span class="gp-frete-precos">' + dinheiro(o.valor) + ' no Pix · ' + dinheiro(cartao50(o.valor, 1, envioDados.appmax)) + ' no cartão</span>' : '') +
        '</label></li>';
    }).join('');
  }
  function cepFormatado(c) { c = String(c || '').replace(/\D/g, ''); return c.length === 8 ? c.slice(0, 5) + '-' + c.slice(5) : c; }
  function enderecoHtml(a) {
    return '<p class="gp-endereco__texto">' + (a.nome ? '<strong>' + esc(a.nome) + '</strong>' : '') +
      '<span>' + esc(a.rua) + (a.numero ? ', ' + esc(a.numero) : '') + (a.complemento ? ' · ' + esc(a.complemento) : '') + '</span>' +
      '<span>' + esc([a.bairro, [a.cidade, a.uf].filter(Boolean).join('/')].filter(Boolean).join(' · ')) + '</span>' +
      '<span>CEP ' + esc(cepFormatado(a.cep)) + '</span></p>';
  }
  function campoEnd(nome, rotulo, extra) {
    return '<label class="glimmer-co__campo' + (extra && extra.inteiro ? ' glimmer-co__campo--inteiro' : '') + '"><span>' + rotulo + '</span>' +
      '<input type="text" name="end-' + nome + '"' + (extra && extra.attrs ? ' ' + extra.attrs : '') + '></label>';
  }
  function envioPronto(e, topo, chips) {
    envioDados = e;
    envioEndereco = envioEndereco || e.endereco;
    var passo = function (n, t) { return '<h3 class="gp-passo"><span>' + n + '</span>' + t + '</h3>'; };
    var metodo = function (valor, nome, info, marcado) {
      return '<label class="gp-metodo"><input type="radio" name="envio-metodo" value="' + valor + '"' + (marcado ? ' checked' : '') + '>' +
        '<span class="gp-metodo__nome">' + nome + '</span><span class="gp-metodo__valor" data-envio-valor="' + valor + '"></span><span class="gp-metodo__info">' + info + '</span></label>';
    };
    return '<section class="gp-bloco gp-envio gp-envio--pronto is-destaque" data-envio data-envio-appmax>' +
      topo(e.total > 1 ? 'Todos os seus produtos chegaram! 🎉' : 'Seu pedido chegou! 🎉', e.total > 1 ? 'Vão juntos, num envio só' : 'Pronto para enviar') +
      '<p class="gp-envio__msg">' + textoEnvio(e) + '</p>' + chips +
      passo(1, 'Escolha o frete') +
      '<ul class="glimmer-co__opcoes" data-envio-opcoes>' + opcoesFreteHtml(e.opcoes, '') + '</ul>' +
      passo(2, 'Endereço de entrega') +
      '<div class="gp-endereco" data-envio-endereco-ver>' + enderecoHtml(envioEndereco) + '<button type="button" class="gp-link" data-envio-alterar>Alterar</button></div>' +
      '<div class="gp-endereco-form" data-envio-endereco-form hidden>' +
        '<div class="gp-endereco-form__grade">' +
          campoEnd('cep', 'CEP', { attrs: 'inputmode="numeric" autocomplete="postal-code" maxlength="9" placeholder="00000-000"' }) +
          campoEnd('rua', 'Rua', { inteiro: true, attrs: 'autocomplete="address-line1"' }) +
          campoEnd('numero', 'Número', { attrs: 'inputmode="numeric"' }) +
          campoEnd('complemento', 'Complemento <em>(opcional)</em>', { attrs: 'autocomplete="address-line2"' }) +
          campoEnd('bairro', 'Bairro', { inteiro: true }) +
          campoEnd('cidade', 'Cidade', { attrs: 'autocomplete="address-level2"' }) +
          campoEnd('uf', 'UF', { attrs: 'maxlength="2" autocomplete="address-level1"' }) +
        '</div>' +
        '<p class="glimmer-co__erro" data-envio-endereco-erro hidden></p>' +
        '<div class="gp-endereco-form__acoes"><button type="button" class="gp-botao gp-botao--contorno" data-envio-endereco-salvar>Usar este endereço</button><button type="button" class="gp-link" data-envio-endereco-cancelar>Cancelar</button></div>' +
      '</div>' +
      passo(3, 'Pagamento') +
      '<div class="gp-metodos" role="radiogroup" aria-label="Forma de pagamento">' + metodo('pix', 'Pix', 'aprovação na hora', true) + metodo('cartao', 'Cartão', e.restante > 0 ? 'até ' + (e.appmax.parcelas_max || 12) + 'x' : 'em 1x', false) + '</div>' +
      '<div data-adiantar-cartao-lugar></div>' +
      '<div class="gp-envio__contas">' +
        (e.restante > 0 ? '<div class="gp-linha"><span>Restante dos pedidos</span><span>' + dinheiro(e.restante) + '</span></div>' : '') +
        '<div class="gp-linha"><span>Frete</span><span data-envio-frete></span></div>' +
        '<div class="gp-linha" data-envio-taxa-linha hidden><span>Acréscimo do cartão</span><span data-envio-taxa></span></div>' +
      '</div>' +
      '<div class="gp-total"><span>Total a pagar</span><strong data-envio-total></strong></div>' +
      '<p class="glimmer-co__erro" data-envio-erro role="alert" hidden></p>' +
      '<button type="button" class="gp-botao gp-botao--cheio" data-envio-pagar></button>' +
      '<div class="glimmer-co__pix" data-envio-pix hidden></div>' +
      '<p class="gp-seguro">Pagamento seguro (' + (ASAAS ? 'Asaas' : 'Pagar.me') + ' e Mercado Pago) · você recebe o rastreio assim que enviarmos</p>' +
      '</section>';
  }
  function caixaEnvioPronto() { return passos.pedidos.querySelector('[data-envio-appmax]'); }
  function erroEnvio(msg) { var e = caixaEnvioPronto() && caixaEnvioPronto().querySelector('[data-envio-erro]'); if (e) { e.innerHTML = msg || ''; e.hidden = !msg; } }
  function totalEnvioPronto(metodo, parcelas, frete) {
    var r = envioDados.restante;
    if (metodo !== 'cartao') { return r + frete; }
    // Acréscimo do cartão (regra do 50%) sobre tudo, frete incluído. Só frete: 1x.
    return cartao50(r + frete, r > 0 ? parcelas : 1, envioDados.appmax);
  }
  function atualizarEnvioPronto(caixa) {
    var r = caixa.querySelector('input[name="envio-frete"]:checked');
    var frete = r ? parseInt(r.getAttribute('data-frete'), 10) : 0;
    var metodo = (caixa.querySelector('input[name="envio-metodo"]:checked') || {}).value || 'pix';
    var maxParc = envioDados.restante > 0 ? (envioDados.appmax.parcelas_max || 12) : 1;
    var sel = camposCartao && camposCartao.querySelector('[data-adiantar-parcelas]');
    if (sel) {
      var atual = Math.min(maxParc, parcelasAdiantar()), html = '';
      for (var i = 1; i <= maxParc; i++) {
        var t = totalEnvioPronto('cartao', i, frete);
        if (i > 1 && Math.floor(t / i) < 500) { break; }   // parcela mínima da Appmax: R$ 5,00
        html += '<option value="' + i + '"' + (i === atual ? ' selected' : '') + '>' + (i === 1 ? '1x de ' + dinheiro(t) + ' (à vista)' : i + 'x de ' + dinheiro(Math.floor(t / i)) + ' · total ' + dinheiro(t)) + '</option>';
      }
      sel.innerHTML = html;
    }
    if (camposCartao) { camposCartao.hidden = metodo !== 'cartao'; }
    var parc = metodo === 'cartao' ? parcelasAdiantar() : 1;
    var total = totalEnvioPronto(metodo, parc, frete);
    var semTaxa = envioDados.restante + frete;
    caixa.querySelector('[data-envio-frete]').textContent = r ? dinheiro(frete) : 'escolha acima';
    caixa.querySelector('[data-envio-taxa-linha]').hidden = !(total > semTaxa);
    caixa.querySelector('[data-envio-taxa]').textContent = dinheiro(total - semTaxa);
    caixa.querySelector('[data-envio-valor="pix"]').textContent = dinheiro(semTaxa);
    caixa.querySelector('[data-envio-valor="cartao"]').textContent = (maxParc > 1 ? 'a partir de ' : '') + dinheiro(totalEnvioPronto('cartao', 1, frete));
    caixa.querySelector('[data-envio-total]').textContent = dinheiro(total);
    var botao = caixa.querySelector('[data-envio-pagar]');
    botao.disabled = !r;
    botao.textContent = !r ? 'Escolha o frete' : (metodo === 'cartao' ? 'Pagar ' + dinheiro(total) + ' no cartão' : 'Gerar Pix de ' + dinheiro(total));
  }
  function abrirFormEndereco(sim) {
    var c = caixaEnvioPronto();
    if (!c) { return; }
    var f = c.querySelector('[data-envio-endereco-form]');
    c.querySelector('[data-envio-endereco-ver]').hidden = sim;
    f.hidden = !sim;
    if (sim) {
      ['cep', 'rua', 'numero', 'complemento', 'bairro', 'cidade', 'uf'].forEach(function (k) { f.querySelector('[name="end-' + k + '"]').value = k === 'cep' ? cepFormatado(envioEndereco.cep) : (envioEndereco[k] || ''); });
      f.querySelector('[data-envio-endereco-erro]').hidden = true;
      f.querySelector('[name="end-cep"]').focus();
    }
  }
  function buscarCep(f) {
    var cep = f.querySelector('[name="end-cep"]').value.replace(/\D/g, '');
    if (cep.length !== 8) { return; }
    fetch('https://viacep.com.br/ws/' + cep + '/json/').then(function (r) { return r.json(); }).then(function (d) {
      if (!d || d.erro) { return; }
      var por = function (k, v) { var el = f.querySelector('[name="end-' + k + '"]'); if (v) { el.value = v; } };
      por('rua', d.logradouro); por('bairro', d.bairro); por('cidade', d.localidade); por('uf', d.uf);
      if (d.logradouro) { f.querySelector('[name="end-numero"]').focus(); }
    }).catch(function () {});
  }
  function salvarEndereco(botao) {
    var c = caixaEnvioPronto();
    var f = c.querySelector('[data-envio-endereco-form]');
    var v = function (k) { return f.querySelector('[name="end-' + k + '"]').value.trim(); };
    var novo = { nome: envioEndereco.nome, cep: v('cep').replace(/\D/g, ''), rua: v('rua'), numero: v('numero'), complemento: v('complemento'), bairro: v('bairro'), cidade: v('cidade'), uf: v('uf').toUpperCase() };
    var erroEl = f.querySelector('[data-envio-endereco-erro]');
    var falta = novo.cep.length !== 8 ? 'Confira o CEP.' : (!novo.rua ? 'Informe a rua.' : (!novo.numero ? 'Informe o número.' : (!novo.bairro ? 'Informe o bairro.' : (!novo.cidade ? 'Informe a cidade.' : (!/^[A-Z]{2}$/.test(novo.uf) ? 'Confira a UF (ex.: SP).' : '')))));
    if (falta) { erroEl.textContent = falta; erroEl.hidden = false; return; }
    var aplicar = function (opcoes) {
      envioEndereco = novo;
      var marcado = (c.querySelector('input[name="envio-frete"]:checked') || {}).value || '';
      if (opcoes) { envioDados.opcoes = opcoes; c.querySelector('[data-envio-opcoes]').innerHTML = opcoesFreteHtml(opcoes, marcado); }
      c.querySelector('[data-envio-endereco-ver]').innerHTML = enderecoHtml(novo) + '<button type="button" class="gp-link" data-envio-alterar>Alterar</button>';
      abrirFormEndereco(false);
      atualizarEnvioPronto(c);
    };
    if (novo.cep === String(envioEndereco.cep)) { aplicar(null); return; }
    ocupado(true, botao);
    chamar('envio-cotar', { body: { cep: novo.cep } }).then(function (d) {
      ocupado(false, botao);
      if (!d.ok) { erroEl.textContent = d.error || 'Não conseguimos calcular o frete para esse CEP.'; erroEl.hidden = false; return; }
      aplicar(d.opcoes);
    }).catch(function () { ocupado(false, botao); erroEl.textContent = 'Sem conexão. Tente novamente.'; erroEl.hidden = false; });
  }
  function conferirEnvio(id, tentativa) {
    conferindoPix = 'envio-' + id;
    chamar('envio-status', { query: 'id=' + encodeURIComponent(id) }).then(function (d) {
      if (conferindoPix !== 'envio-' + id) { return; }
      if (d.status === 'pago') { conferindoPix = null; avisar('Pagamento confirmado! Vamos preparar o envio ' + ((d.pedidos || []).length > 1 ? 'dos pedidos ' : 'do pedido ') + (d.pedidos || []).join(', ') + ' e você recebe o rastreio por e-mail.', 'ok'); carregarPedidos(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      if (d.status === 'em-analise') { conferindoPix = null; avisar('Recebemos seu pagamento e estamos conferindo. Falaremos com você se precisarmos de algo.', 'aviso'); carregarPedidos(); return; }
      if (d.status === 'recusado') { conferindoPix = null; erroEnvio('O pagamento não foi aprovado. Tente de novo.'); return; }
      if (tentativa < 180) { setTimeout(function () { conferirEnvio(id, tentativa + 1); }, 5000); }
    }).catch(function () { if (tentativa < 180 && conferindoPix === 'envio-' + id) { setTimeout(function () { conferirEnvio(id, tentativa + 1); }, 5000); } });
  }
  function pagarEnvioPronto(botao) {
    var c = caixaEnvioPronto();
    var r = c.querySelector('input[name="envio-frete"]:checked');
    if (!r) { erroEnvio('Escolha o frete.'); return; }
    if (!c.querySelector('[data-envio-endereco-form]').hidden) { erroEnvio('Confirme o endereço em "Usar este endereço".'); return; }
    var metodo = (c.querySelector('input[name="envio-metodo"]:checked') || {}).value || 'pix';
    erroEnvio('');
    ocupado(true, botao);
    var preparar = metodo === 'cartao' ? tokenizarCartao() : Promise.resolve('');
    preparar.then(function (token) {
      var titular = metodo === 'cartao' ? camposCartao.querySelector('[name="card-holder-name"]').value.trim() : '';
      return chamar('pagar-envio', { body: { opcao: r.value, metodo: metodo, endereco: envioEndereco, appmax: { token: token || '', parcelas: metodo === 'cartao' ? parcelasAdiantar() : 1, ip: appmaxIp, titular: titular } } });
    }).then(function (d) {
      ocupado(false, botao);
      if (d._status === 401) { gravar(CHAVE_SESSAO, ''); telaEntrar(); avisar('Sua sessão expirou. Entre de novo.', 'aviso'); return; }
      if (!d.ok) { erroEnvio(esc(d.error || 'Não foi possível gerar o pagamento.')); return; }
      if (d.pix) {
        botao.disabled = true; botao.textContent = 'Aguardando o Pix...';
        c.querySelectorAll('input, [data-envio-alterar]').forEach(function (el) { el.disabled = true; });
        var caixa = c.querySelector('[data-envio-pix]');
        var img = d.pix.qr_code ? (/^data:|^https?:/.test(d.pix.qr_code) ? d.pix.qr_code : 'data:image/png;base64,' + d.pix.qr_code) : '';
        caixa.innerHTML = '<p class="glimmer-co__pix-titulo">Pague com Pix</p>' +
          (img ? '<img class="glimmer-co__pix-qr" alt="QR code do Pix" src="' + img + '">' : '') +
          '<label class="glimmer-co__campo glimmer-co__campo--inteiro"><span>Pix copia e cola</span><input type="text" readonly data-adiantar-pix-codigo></label>' +
          '<button type="button" class="glimmer-co__botao glimmer-co__botao--leve" data-adiantar-pix-copiar>Copiar código</button>' +
          avisoRecebedorPix(d.pix.copia_e_cola, d.pix.recebedor) +
          '<p class="glimmer-co__ajuda">Aguardando o pagamento... assim que o Pix for confirmado, esta página atualiza sozinha.</p>';
        var cod = caixa.querySelector('[data-adiantar-pix-codigo]'); cod.value = d.pix.copia_e_cola || ''; cod.disabled = false;
        caixa.hidden = false;
        caixa.scrollIntoView({ behavior: 'smooth', block: 'center' });
        conferirEnvio(d.id, 0);
        return;
      }
      if (d.status === 'pago') { avisar('Pagamento confirmado! Vamos preparar o envio e você recebe o rastreio por e-mail.', 'ok'); carregarPedidos(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      botao.disabled = true; botao.textContent = 'Confirmando o pagamento...';
      var notaE = c.querySelector('[data-envio-pix]');
      if (notaE) { notaE.innerHTML = '<p class="glimmer-co__ajuda"><strong>Pagamento no cartão enviado!</strong> A operadora está confirmando. Costuma levar até 2 minutos e esta página atualiza sozinha. Pode sair: avisamos por WhatsApp e e-mail.</p>'; notaE.hidden = false; }
      conferirEnvio(d.id, 0);
    }).catch(function (msg) {
      ocupado(false, botao);
      erroEnvio(esc(typeof msg === 'string' ? msg : 'Sem conexão. Tente novamente.'));
    });
  }
  function atualizarEnvio() {
    var pronto = caixaEnvioPronto();
    if (pronto) { atualizarEnvioPronto(pronto); return; }
    var caixa = passos.pedidos.querySelector('[data-envio]');
    if (!caixa) { return; }
    var r = caixa.querySelector('input[name="envio-frete"]:checked');
    if (!r) { return; }
    caixa.querySelector('[data-envio-frete]').textContent = dinheiro(parseInt(r.getAttribute('data-frete'), 10));
    caixa.querySelector('[data-envio-total]').textContent = dinheiro(parseInt(r.getAttribute('data-total-cartao'), 10));
    caixa.querySelector('[data-pagar-envio]').textContent = 'Pagar ' + dinheiro(parseInt(r.getAttribute('data-total-cartao'), 10)) + ' no cartão';
  }

  function carregarPedidos() {
    mostrar('pedidos');
    if (camposCartao) { camposCartao.hidden = true; raiz.appendChild(camposCartao); }   // tira o cartão do quadro antes de limpar
    conferindoPix = null;
    envioEndereco = null;
    passos.pedidos.innerHTML = '';
    rastreiosGuardados = [];
    ocupado(true);
    chamar('pedidos').then(function (d) {
      ocupado(false);
      if (d._status === 401) { gravar(CHAVE_SESSAO, ''); avisar('Sua sessão expirou. Entre de novo.', 'aviso'); telaEntrar(); return; }
      if (!d.ok) { avisar(d.error || 'Não foi possível carregar seus pedidos.', 'aviso'); return; }
      $('[data-conta-quem]').textContent = d.email || ler(CHAVE_EMAIL);
      if (d.nome) { gravar(CHAVE_NOME, d.nome); }
      cumprimentar(d.nome || ler(CHAVE_NOME));
      ola.hidden = false;
      var pedidos = d.pedidos || [];
      adiantarDados = (d.adiantar && APPMAX_ID && camposCartao) ? d.adiantar : null;
      envioDados = null;
      var finalizados = pedidos.filter(function (p) { return p.situacao === 'entregue' || p.situacao === 'cancelado'; });
      var andamento = pedidos.filter(function (p) { return finalizados.indexOf(p) < 0; });
      pontosPorPedido = (d.pontos && d.pontos.por_pedido) || {};
      var lateral = cartaoAdiantar(adiantarDados) + cartaoEnvio(d.envio);
      var abaInicial = andamento.length ? 'andamento' : 'finalizados';
      var aba = function (nome, titulo, lista) {
        return '<button type="button" class="gp-aba' + (nome === abaInicial ? ' is-ativa' : '') + '" role="tab" aria-selected="' + (nome === abaInicial) + '" data-gp-aba="' + nome + '">' + titulo + ' <span>' + lista.length + '</span></button>';
      };
      var grupo = function (nome, lista, antes) {
        return '<div class="gp-grupo" data-gp-grupo="' + nome + '"' + (nome === abaInicial ? '' : ' hidden') + '>' + (antes || '') +
          (lista.length ? lista.map(cartao).join('') : '<p class="gp-vazio">' + (nome === 'andamento' ? 'Nenhum pedido em andamento.' : 'Nenhum pedido finalizado ainda.') + '</p>') + '</div>';
      };
      passos.pedidos.innerHTML = pedidos.length
        ? (d.pontos ? '<div class="gp-resumo">' + cartaoPontos(d.pontos) + '</div>' : '') +
          '<div class="gp-painel' + (lateral ? '' : ' is-sem-lateral') + '">' +
            (lateral ? '<aside class="gp-lateral">' + lateral + '</aside>' : '') +
            '<div class="gp-lista">' +
              (finalizados.length && andamento.length ? '<div class="gp-abas" role="tablist">' + aba('andamento', 'Em andamento', andamento) + aba('finalizados', 'Finalizados', finalizados) + '</div>' : '') +
              grupo('andamento', andamento, faixaEnvio(d.envio)) + grupo('finalizados', finalizados) +
            '</div>' +
          '</div>'
        : '<div class="glimmer-conta__vazio"><p class="glimmer-conta__texto">Ainda não há pedidos com este e-mail.</p><a class="glimmer-co__botao" href="/collections/all">Ver produtos</a></div>';
      atualizarEnvio();
      var lugar = passos.pedidos.querySelector('[data-adiantar-cartao-lugar]');
      if (lugar && camposCartao) { lugar.appendChild(camposCartao); iniciarAppmax(); }
      atualizarAdiantar();
    }).catch(function () { ocupado(false); avisar('Sem conexão. Recarregue a página.', 'aviso'); });
  }

  raiz.addEventListener('change', function (e) {
    if (!e.target) { return; }
    if (e.target.name === 'envio-frete') { atualizarEnvio(); }
    if (e.target.name === 'envio-metodo') { erroEnvio(''); atualizarEnvio(); }
    if (e.target.hasAttribute('data-adiantar-parcelas') && caixaEnvioPronto()) { atualizarEnvio(); return; }
    if (e.target.name === 'adiantar-pedido' || e.target.name === 'adiantar-metodo' || e.target.hasAttribute('data-adiantar-parcelas')) { erroAdiantar(''); atualizarAdiantar(); }
  });

  raiz.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'end-cep') {
      var d = e.target.value.replace(/\D/g, '').slice(0, 8);
      e.target.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
      if (d.length === 8) { buscarCep(e.target.closest('[data-envio-endereco-form]')); }
    }
  });
  raiz.addEventListener('click', function (e) {
    var abaBotao = e.target.closest('[data-gp-aba]');
    if (abaBotao) {
      var nomeAba = abaBotao.getAttribute('data-gp-aba');
      passos.pedidos.querySelectorAll('[data-gp-aba]').forEach(function (b) { var sim = b === abaBotao; b.classList.toggle('is-ativa', sim); b.setAttribute('aria-selected', sim); });
      passos.pedidos.querySelectorAll('[data-gp-grupo]').forEach(function (g) { g.hidden = g.getAttribute('data-gp-grupo') !== nomeAba; });
      return;
    }
    if (e.target.closest('[data-envio-alterar]')) { abrirFormEndereco(true); return; }
    if (e.target.closest('[data-envio-endereco-cancelar]')) { abrirFormEndereco(false); return; }
    var bse = e.target.closest('[data-envio-endereco-salvar]');
    if (bse) { salvarEndereco(bse); return; }
    var bpe = e.target.closest('[data-envio-pagar]');
    if (bpe) { pagarEnvioPronto(bpe); return; }
    var ba = e.target.closest('[data-adiantar-pagar]');
    if (ba) { pagarAdiantar(ba); return; }
    var bab = e.target.closest('[data-adiantar-abrir]');
    if (bab) { abrirAdiantar(bab.getAttribute('aria-expanded') !== 'true'); return; }
    var bu = e.target.closest('[data-adiantar-um]');
    if (bu) {
      var caixa = caixaAdiantar();
      if (!caixa) { return; }
      caixa.querySelectorAll('input[name="adiantar-pedido"]').forEach(function (el) { el.checked = el.value === bu.getAttribute('data-adiantar-um'); });
      abrirAdiantar(true);
      atualizarAdiantar();
      caixa.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var bc = e.target.closest('[data-adiantar-pix-copiar]');
    if (bc) {
      var cod = bc.closest('.glimmer-co__pix').querySelector('[data-adiantar-pix-codigo]'); cod.select();
      try { navigator.clipboard.writeText(cod.value); } catch (er) { document.execCommand('copy'); }
      bc.textContent = 'Código copiado!';
      return;
    }
    var be = e.target.closest('[data-pagar-envio]');
    if (be) {
      var escolhido = passos.pedidos.querySelector('input[name="envio-frete"]:checked');
      if (!escolhido) { avisar('Escolha uma opção de frete.', 'aviso'); return; }
      ocupado(true, be);
      chamar('pagar-envio', { body: { opcao: escolhido.value } }).then(function (d) {
        if (d.ok && d.url) { if (window.glimmerIr) { window.glimmerIr(d.url); } else { window.location.href = d.url; } return; }
        ocupado(false, be);
        if (d._status === 401) { gravar(CHAVE_SESSAO, ''); telaEntrar(); }
        avisar(d.error || 'Não foi possível gerar o pagamento.', 'aviso');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }).catch(function () { ocupado(false, be); avisar('Sem conexão. Tente novamente.', 'aviso'); });
      return;
    }
    var det = e.target.closest('[data-rastreio]');
    if (det) { abrirRastreio(parseInt(det.getAttribute('data-rastreio'), 10)); return; }
    var b = e.target.closest('[data-pagar]');
    if (!b) { return; }
    ocupado(true, b);
    chamar('pagar', { body: { pedido: b.getAttribute('data-pagar'), metodo: b.getAttribute('data-metodo') } }).then(function (d) {
      if (d.ok && d.url) { if (window.glimmerIr) { window.glimmerIr(d.url); } else { window.location.href = d.url; } return; }
      ocupado(false, b);
      if (d._status === 401) { gravar(CHAVE_SESSAO, ''); telaEntrar(); }
      avisar(d.error || 'Não foi possível gerar o pagamento.', 'aviso');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }).catch(function () { ocupado(false, b); avisar('Sem conexão. Tente novamente.', 'aviso'); });
  });

  // --- Volta da InfinitePay (restante pago) ----------------------------------------
  function confirmarSaldo(params, tentativa) {
    chamar('saldo', { query: params.toString() }).then(function (d) {
      if (d.status === 'pago') { avisar('Pagamento do restante confirmado! Vamos preparar o envio do pedido ' + (d.pedido || '') + '.', 'ok'); if (ler(CHAVE_SESSAO)) { carregarPedidos(); } return; }
      if (d.status === 'em-analise') { avisar('Recebemos seu pagamento e estamos conferindo. Falaremos com você se precisarmos de algo.', 'aviso'); if (ler(CHAVE_SESSAO)) { carregarPedidos(); } return; }
      if (tentativa < 15) { setTimeout(function () { confirmarSaldo(params, tentativa + 1); }, 3000); return; }
      avisar('Ainda não recebemos a confirmação do pagamento. Se você já pagou, ela pode levar alguns minutos.', 'aviso');
    }).catch(function () { if (tentativa < 15) { setTimeout(function () { confirmarSaldo(params, tentativa + 1); }, 3000); } });
  }
  // --- Volta da InfinitePay (envio: frete + restantes) ---
  function confirmarEnvio(params, tentativa) {
    chamar('envio', { query: params.toString() }).then(function (d) {
      if (d.status === 'pago') { avisar('Pagamento confirmado! Vamos preparar o envio ' + ((d.pedidos || []).length > 1 ? 'dos pedidos ' : 'do pedido ') + (d.pedidos || []).join(', ') + '.', 'ok'); if (ler(CHAVE_SESSAO)) { carregarPedidos(); } return; }
      if (d.status === 'em-analise') { avisar('Recebemos seu pagamento e estamos conferindo. Falaremos com você se precisarmos de algo.', 'aviso'); if (ler(CHAVE_SESSAO)) { carregarPedidos(); } return; }
      if (tentativa < 15) { setTimeout(function () { confirmarEnvio(params, tentativa + 1); }, 3000); return; }
      avisar('Ainda não recebemos a confirmação do pagamento. Se você já pagou, ela pode levar alguns minutos.', 'aviso');
    }).catch(function () { if (tentativa < 15) { setTimeout(function () { confirmarEnvio(params, tentativa + 1); }, 3000); } });
  }

  var url = new URLSearchParams(window.location.search);
  var nsuEnvio = url.get('envio') || url.get('order_nsu');
  if (nsuEnvio && /^GLE/.test(nsuEnvio)) {
    avisar('Confirmando seu pagamento...', '');
    confirmarEnvio(new URLSearchParams({ nsu: nsuEnvio, transaction_nsu: url.get('transaction_nsu') || '', slug: url.get('slug') || url.get('invoice_slug') || '' }), 0);
  }
  var nsuSaldo = url.get('saldo') || url.get('order_nsu');
  if (nsuSaldo && /^GLS/.test(nsuSaldo)) {
    avisar('Confirmando seu pagamento...', '');
    confirmarSaldo(new URLSearchParams({ nsu: nsuSaldo, transaction_nsu: url.get('transaction_nsu') || '', slug: url.get('slug') || url.get('invoice_slug') || '' }), 0);
  }

  if (ler(CHAVE_SESSAO)) { carregarPedidos(); } else { telaEntrar(); }
})();
